import { useSelector } from "react-redux";
import { State } from "../props/State.props";

function DownloadResumeJSON() {
  const getResumeData = useSelector((state: State) => state.getResumeData);

  return (
    <div
      className={`flex items-center gap-3 text-sm font-semibold rounded-lg bg-[#2a3035] text-dark-fg cursor-pointer mb-2 p-4 text-center`}
      title="Download Resume JSON"
      onClick={() => {
        const date = new Date();
        const getJSON =
          "data:text/json;charset=utf-8," +
          encodeURIComponent(JSON.stringify(getResumeData));
        const anchorNode = document.createElement("a");
        anchorNode.setAttribute("href", getJSON);
        anchorNode.setAttribute(
          "download",
          `${getResumeData.name.replace(/ /gi, "_")}_${date
            .toDateString()
            .replace(/ /gi, "_")}_${date.getTime()}`
        );
        anchorNode.click();
        anchorNode.remove();
      }}
    >
      <i className="fa fa-file" />
      <div className="text-left">Download Resume JSON</div>
    </div>
  );
}

export default DownloadResumeJSON;
